import { render, staticRenderFns } from "./electronicDetails.vue?vue&type=template&id=3bdfb839&scoped=true"
import script from "./electronicDetails.vue?vue&type=script&lang=js"
export * from "./electronicDetails.vue?vue&type=script&lang=js"
import style0 from "./electronicDetails.vue?vue&type=style&index=0&id=3bdfb839&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdfb839",
  null
  
)

export default component.exports